module.exports = __webpack_public_path__ + "img/asset3.4704eea6.png";